import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface AccountState {
  isSettingsOpen: boolean;
  isModalOpen: boolean;
}

const initialState: AccountState = {
  isSettingsOpen: false,
  isModalOpen: false,
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setSettingsOpen(state, action: PayloadAction<boolean>) {
      state.isSettingsOpen = action.payload;
    },
    toggleSettings(state, action: PayloadAction<boolean>) {
      state.isSettingsOpen = action.payload;
    },
    setModalOpen(state, action: PayloadAction<boolean>) {
      state.isModalOpen = action.payload;
    },
    toggleModal(state, action: PayloadAction<boolean>) {
      state.isModalOpen = action.payload;
    },
  },
});

export const { setSettingsOpen, toggleSettings, setModalOpen, toggleModal } =
  accountSlice.actions;

export default accountSlice.reducer;
